import { BrandMutation, InternalBrand } from '../features/brands/types/InternalBrand'
import { internalApiserverApi } from './internal-apiserver'

const brandsApi = internalApiserverApi.enhanceEndpoints({ addTagTypes: ['internalBrands'] }).injectEndpoints({
  endpoints: (builder) => ({
    getInternalBrands: builder.query<InternalBrand[], void>({
      query: () => 'brands/',
      providesTags: ['internalBrands'],
    }),
    getInternalBrand: builder.query<InternalBrand, string>({
      query: (id) => `brands/${id}`,
      providesTags: (_result, _error, id) => [{ type: 'internalBrands', id }],
    }),
    // Answers the stored brand. Staging's PUT stores only `names` and keeps the stored `owner` and `tags`.
    saveInternalBrand: builder.mutation<InternalBrand, BrandMutation>({
      query: (brand) => ({ url: 'i/brands', method: brand.id ? 'PUT' : 'POST', body: brand }),
      invalidatesTags: ['internalBrands'],
    }),
    deleteInternalBrand: builder.mutation<string, string>({
      query: (id) => ({ url: `i/brands/${id}`, method: 'DELETE', responseHandler: 'text' }),
      // Not the list: the page refetches it to confirm the delete, and a refetch started by invalidation
      // makes that refetch resolve right away with the list from before the delete.
      invalidatesTags: (_result, _error, id) => [{ type: 'internalBrands', id }],
    }),
  }),
})

export const { useGetInternalBrandsQuery, useGetInternalBrandQuery, useSaveInternalBrandMutation, useDeleteInternalBrandMutation } = brandsApi
